// import { BreadcrumbsService, Breadcrumb } from '@exalif/ngx-breadcrumbs';
import { AuthService } from '../../core/services/acceso/auth.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Configuration } from '../../core/configuration/configuration';
// import { Usuario } from '../../core/models/usuario.model';
// import { Empresa } from '../../core/models/empresa.model';
// import { UsuarioService } from '../../core/services/core/usuario.service';
// import { EmpresaService } from '../../core/services/organizacion/empresa.service';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { User } from '../../core/models/user.model';
import { A3LCompany } from '../../core/models/a3LCompany.model';
import { A3LCompanyService } from '../../core/services/a3LCompany.service';

const misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0
};

declare var $: any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  providers: [A3LCompanyService]
})
export class NavbarComponent implements OnInit {

  proyectName: string;
  location: Location;
  mobileMenuVisible: any = 0;
  supportModalId = 'support';
  private nativeElement: Node;
  private toggleButton: any;
  private sidebarVisible: boolean;

  private subscription: Subscription;
  usuario: User;
  empresa: string;

  @ViewChild('app-navbar') button: any;

  constructor(
    location: Location,
    private element: ElementRef,
    private _authService: AuthService,
    private _ngxSmartModalService: NgxSmartModalService,
    private router: Router,
    private _session: SessionHelper,
  ) {
    this.proyectName = Configuration.proyectName;
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  cargarUsuario(): void {
    this.usuario = this._session.User;
  }

  cargarEmpresa(): void {
    this.empresa = this._session.CompanyName;
    // this._empresaService
    //    .getModel(this._session.CompanyCode)
    //    .subscribe(res => (this.empresa = res));
  }

  minimizeSidebar(): void {
    const body = document.getElementsByTagName('body')[0];

    if (misc.sidebar_mini_active === true) {
      body.classList.remove('sidebar-mini');
      misc.sidebar_mini_active = false;
    } else {
      setTimeout((): void => {
          body.classList.add('sidebar-mini');

          misc.sidebar_mini_active = true;
        }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
        window.dispatchEvent(new Event('resize'));
      }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(() => {
        clearInterval(simulateWindowResize);
      }, 1000);
  }

  hideSidebar(): void {
    const body = document.getElementsByTagName('body')[0];
    const sidebar = document.getElementsByClassName('sidebar')[0];

    if (misc.hide_sidebar_active === true) {
      setTimeout(() => {
        body.classList.remove('hide-sidebar');
        misc.hide_sidebar_active = false;
      }, 300);
      setTimeout(() => {
        sidebar.classList.remove('animation');
      }, 600);
      sidebar.classList.add('animation');
    } else {
      setTimeout(() => {
        body.classList.add('hide-sidebar');
        // $('.sidebar').addClass('animation');
        misc.hide_sidebar_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  ngOnInit(): void {
    const body = document.getElementsByTagName('body')[0];
    this.toggleButton = document.getElementsByClassName('navbar-toggler')[0];

    if (body.classList.contains('sidebar-mini')) {
      misc.sidebar_mini_active = true;
    }
    if (body.classList.contains('hide-sidebar')) {
      misc.hide_sidebar_active = true;
    }
    this.subscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        const $layer = document.getElementsByClassName('close-layer')[0];
        if ($layer) {
          $layer.remove();
        }
        this.sidebarVisible = false;
        this.mobileMenuVisible = 0;
      });

    this.cargarUsuario();
    this.cargarEmpresa();
  }

  onResize(event) {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    setTimeout(() => {
      toggleButton.classList.add('toggled');
    }, 500);
    body.classList.add('nav-open');

    this.sidebarVisible = true;
  }

  sidebarClose() {
    const body = document.getElementsByTagName('body')[0];
    this.toggleButton.classList.remove('toggled');
    this.sidebarVisible = false;
    body.classList.remove('nav-open');
    const $layer = document.getElementsByClassName('close-layer')[0];
    if ($layer) {
      $layer.remove();
    }
  }

  sidebarToggle(): void {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const body = document.getElementsByTagName('body')[0];

    var $toggle = document.getElementsByClassName('navbar-toggler')[0];
    if (this.mobileMenuVisible === 1) {
      // $('html').removeClass('nav-open');
      body.classList.remove('nav-open');
      if ($layer) {
        $layer.remove();
      }

      setTimeout(() => {
        $toggle.classList.remove('toggled');
      }, 400);

      this.mobileMenuVisible = 0;
    } else {
      setTimeout(() => {
        $toggle.classList.add('toggled');
      }, 430);

      var $layer = document.createElement('div');
      $layer.setAttribute('class', 'close-layer');

      if (body.querySelectorAll('.main-panel')) {
        document.getElementsByClassName('main-panel')[0].appendChild($layer);
      } else if (body.classList.contains('off-canvas-sidebar')) {
        document
          .getElementsByClassName('wrapper-full-page')[0]
          .appendChild($layer);
      }

      setTimeout(() => {
        $layer.classList.add('visible');
      }, 100);

      $layer.onclick = (() => {
        // asign a function
        body.classList.remove('nav-open');
        this.mobileMenuVisible = 0;
        this.sidebarVisible = false;
        $layer.classList.remove('visible');
        setTimeout(() => {
          $layer.remove();
          $toggle.classList.remove('toggled');
        }, 400);
      }).bind(this);

      body.classList.add('nav-open');
      this.mobileMenuVisible = 1;
    }
  }


  isMobileMenu(): boolean {
    if ($(window).width() < 991) {
      return false;
    }
    return true;
  }

  logOutClick() {
    this._authService.logout();
  }

  showSupportForm() {
    if (this._ngxSmartModalService) {
      this._ngxSmartModalService.getModal(this.supportModalId).open();
    }
  }

  redirectLCX() {
    window.open('https://customer.linksoluciones.com/', '_blank');

  }
}
